import React from "react";
import clsx from "clsx";

import makeStyles from "@mui/styles/makeStyles";

import { Measurement, MeasurementDetail, PanelMeasurement } from "../../shared/interfaces/Result";
import { MeasurementComponent } from "../../shared/enums/Result";
import { CableNaming } from "../../shared/enums/UTP2";
import { getSublocationLayoutByComponentType } from "../../shared/helpers/SubLocationHelpers";

import { ComponentMeasurementIcons } from "../ComponentMeasurementIcons";

interface Props {
  panelMeasurement?: PanelMeasurement;
  componentType: MeasurementComponent;
  onIconClick: (measurement: MeasurementDetail<Measurement>, position: number | undefined, newTab: boolean) => void;
  cableNaming?: CableNaming;
}

const useStyles = makeStyles(() => ({
  table: {
    display: "table",
    padding: "5px",
    width: "100%",
    height: "100%",
    borderCollapse: "collapse",
    borderStyle: "hidden",
  },
  row: {
    display: "table-row",
    minHeight: "100opx",
  },

  cell: {
    display: "table-cell",
    textAlign: "center",
    width: "33%",
    minHeight: "1em",
    padding: "10px",
    border: "1px solid #dcdcdc",
  },
}));

export function SubLocationGrid(props: Props) {
  const classes = useStyles();

  const measurementComponentLayout = getSublocationLayoutByComponentType(props.componentType);

  return (
    <React.Fragment>
      <div className={classes.table}>
        {measurementComponentLayout?.rows.map((row, index) => {
          return (
            <div key={`${index}-cell`} className={classes.row}>
              {row.columns.map((sublocation) => {
                return (
                  <div key={`${sublocation}-cell`} className={clsx(classes.cell)}>
                    {props.panelMeasurement && (
                      <ComponentMeasurementIcons
                        onIconClick={(measurement, position, newTab) => {
                          props.onIconClick(measurement, position, newTab);
                        }}
                        panelMeasurement={props.panelMeasurement}
                        componentType={props.componentType}
                        sublocation={sublocation}
                        cableNaming={props.cableNaming}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
}
